type SurfaceFields = {
  living_surface?: number | null;
  built_surface?: number | null;
  number_of_rooms?: number | null;
  number_of_bedrooms?: number | null;
};

export const getSurface = (
  data: SurfaceFields | null | undefined,
  isSpanish: boolean,
) => {
  if (!data) return null;
  if (isSpanish) return data.built_surface ?? null;
  return data.living_surface ?? null;
};

export const getRooms = (
  data: SurfaceFields | null | undefined,
  isSpanish: boolean,
) => {
  if (!data) return null;
  if (isSpanish) return data.number_of_bedrooms ?? null;
  return data.number_of_rooms ?? null;
};
